import { mergeWith } from 'lodash';
import { ResourcePriority, ResourceTag, ResourceType, TranslationProject, } from '../../models/resource';
export class TranslationResourceUtilsClass {
    /**
     * @deprecated
     * remove when all services will use new api
     */
    async loadTranslationObjectK2(resources, appConfig, ...moduleNames) {
        return this.loadTranslationObject(resources, appConfig, ...moduleNames);
    }
    async loadTranslationObject(resources, appConfig, ...moduleNames) {
        await resources.addResources(TranslationResourceUtils.getDescriptors(appConfig, ...moduleNames.map((moduleName) => ({
            name: moduleName,
            project: TranslationProject.UXA,
        }))));
        return mergeWith({}, ...moduleNames.map((moduleName) => mergeWith({}, ...resources.getModuleTranslations(moduleName, appConfig.locale))));
    }
    getDescriptors(appConfig, ...modules) {
        const descriptors = [];
        if (!appConfig.translationUrl) {
            throw new Error('Configuration is not set. TranslationUrl is not defined');
        }
        modules.forEach((module) => {
            const devices = appConfig.isSDK ? [ResourceTag.SDK] : [ResourceTag.WEB];
            const translationFolder = `${appConfig.translationUrl}/${module.project}/${appConfig.locale}`;
            if (devices.length) {
                descriptors.push(...(devices || []).map((device) => {
                    return {
                        module: module.name,
                        key: `${translationFolder}/${this.getTranslationFileName(device, module)}`,
                        tags: [device],
                        priority: module.priority || ResourcePriority.DefaultOverride,
                        locale: appConfig.locale,
                        type: ResourceType.TRANSLATION,
                    };
                }));
            }
        });
        return descriptors;
    }
    getTranslationFileName(device, module) {
        const defaultDevice = ResourceTag.WEB;
        return defaultDevice === device ? `${module.name}.json` : `${module.name}-${device}.json`;
    }
}
export const TranslationResourceUtils = new TranslationResourceUtilsClass();
//# sourceMappingURL=translation-resource.utils.service.js.map